import React from "react";
import PropTypes from "prop-types";

const Filtering = ({
  children,
  locations,
  location,
  positions,
  position,
  currentUserHasScheduleManageAccess,
  page,
  onChangeLocation,
  onChangePosition,
}) => (
  <div className="row">
    <div className="col-md-2 col-xs-12">
      <select className="form-control" aria-label='select location' value={location} onChange={onChangeLocation}>
        {locations.map(item => (
          <option key={item.id} value={item.id}>
            {item.value}
          </option>
        ))}
      </select>
    </div>
    <div className="col-md-2 col-xs-12">
      <select className="form-control" aria-label='select position' value={position} onChange={onChangePosition}>
        {positions.map(item => (
          <option key={item.id} value={item.id}>
            {item.value}
          </option>
        ))}
      </select>
    </div>

    {currentUserHasScheduleManageAccess ? (
      <div className="col-md-7 pull-right pull-right">
        <div className="pull-right">
          {page === "pending" ? null : (
            <a
              className="btn btn-pink btn-raised margin-right-five"
              href="/sub_requests_pending_approval"
            >
              PENDING APPROVAL
            </a>
          )}

          {page === "pending" ? (
            <a
              className="btn btn-pink btn-raised btn-long margin-right-five"
              href="/processed_sub_requests"
            >
              PROCESSED
            </a>
          ) : null}

          {page === "open" ? (
            <a
              className="btn btn-indigo btn-raised btn-long margin-right-five"
              href="/processed_sub_requests"
            >
              PROCESSED
            </a>
          ) : null}

          {page === "open" ? null : (
            <a
              className="btn btn-indigo btn-raised btn-long margin-right-five"
              href="/sub_requests"
            >
              OPEN
            </a>
          )}

          {children}
        </div>
        <div className="visible-xs">
          <br />
          <br />
          <br />
        </div>
      </div>
    ) : null}
  </div>
);

Filtering.propTypes = {
  locations: PropTypes.array.isRequired,
  location: PropTypes.string,
  positions: PropTypes.array.isRequired,
  position: PropTypes.string,
  currentUserHasScheduleManageAccess: PropTypes.bool,
  page: PropTypes.string,
  onChangeLocation: PropTypes.func,
  onChangePosition: PropTypes.func,
};

export default Filtering;
